var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "note",
  "use": "note-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"note\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\"><circle cx=\"7\" cy=\"23\" r=\"3\" /><circle cx=\"20\" cy=\"20\" r=\"3\" /><path d=\"M23 20V4L10 8v15M23 8l-13 4\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol